// Module
var code = `{{#.colorStyleWidth}}
{{#if .CheckBoxVisible}}
<reactFormLabel label="{{~/labelText}}">
    <reactCheckbox 
        checked="{{.Checked}}" 
        on-onChange="@this.onActiveChanged(\$1)" />
</reactFormLabel>
<div class="combobox-color-widthStyle-picker">
    {{>colorAndLineStyle}}
</div>
{{else}}
<terceraLabel text="{{~/labelText}}" />
<div class="combobox-color-widthStyle-picker">
    {{>colorAndLineStyle}}
</div>
{{/if}}
{{/}}

{{#partial colorAndLineStyle}}
{{#if !.DisableColor && !.DisableStyle && !.DisableWidth}}
<terceraLineStyleComboBox enabled="{{ ~/enabled && (.Checked || !(.CheckBoxVisible)) }}" selectedItem="{{~/selectedLineStyleItem}}" items="{{~/styleItems}}" useStyleProperties="{{~/useStyleProperties}}" />
<terceraWidthComboBox enabled="{{ ~/enabled && (.Checked || !(.CheckBoxVisible)) }}" selectedItem="{{~/selectedLineWidthItem}}" items="{{widthItems}}" />
<terceraButtonColorPicker enabled="{{ ~/enabled && (.Checked || !(.CheckBoxVisible)) }}" coloringButtonColor="{{.Color}}" />
{{elseif .DisableColor && .DisableWidth}}
<terceraLineStyleComboBox enabled="{{ ~/enabled && (.Checked || !(.CheckBoxVisible)) }}" selectedItem="{{~/selectedLineStyleItem}}" items="{{~/styleItems}}" useStyleProperties="{{~/useStyleProperties}}" />
{{elseif .DisableColor}}
<terceraLineStyleComboBox enabled="{{ ~/enabled && (.Checked || !(.CheckBoxVisible)) }}" selectedItem="{{~/selectedLineStyleItem}}" items="{{~/styleItems}}" useStyleProperties="{{~/useStyleProperties}}" />
<terceraWidthComboBox enabled="{{ ~/enabled && (.Checked || !(.CheckBoxVisible)) }}" selectedItem="{{~/selectedLineWidthItem}}" items="{{widthItems}}" />
{{else}}
<terceraLineStyleComboBox enabled="{{ ~/enabled && (.Checked || !(.CheckBoxVisible)) }}" selectedItem="{{~/selectedLineStyleItem}}" items="{{~/styleItems}}" useStyleProperties="{{~/useStyleProperties}}" />
<terceraButtonColorPicker enabled="{{ ~/enabled && (.Checked || !(.CheckBoxVisible)) }}" coloringButtonColor="{{.Color}}" />
{{/if}}
{{/partial}}`;
// Exports
export default code;